import { AbstractControl, ValidationErrors, Validators } from '@angular/forms';

export function PasswordValidator(isPasswordNumeric) {
  const passwordRegex = '^[0-9a-zA-Z!@#$%^&*\\(\\)\\[\\]{};:<>,.\\/\\\\|?]+$';
  const passwordNumericRegex = '^[0-9]+$';

  return (control: AbstractControl): ValidationErrors | null => {
    if (isPasswordNumeric && Validators.pattern(passwordNumericRegex)(control)) {
      return { mustBeNumeric: true };
    }

    if (Validators.pattern(passwordRegex)(control)) {
      return { invalidSpecialCharacter: true };
    }

    if (Validators.minLength(4)(control) || Validators.maxLength(20)(control)) {
      return { characterLimit: true };
    }

    return null;
  };
}
